import { Fingerprint, ScanFace, ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useBiometricAuth } from "@/hooks/useBiometricAuth";
import { hapticSuccess, hapticError } from "@/lib/despiaHaptics";
import { toast } from "sonner";

export function BiometricSettings() {
  const { 
    isAvailable, 
    isEnabled, 
    biometryType, 
    isLoading,
    enableBiometric, 
    disableBiometric,
    getBiometryName 
  } = useBiometricAuth();

  // Don't show if biometric not available
  if (!isAvailable || isLoading) {
    return null;
  }

  const Icon = biometryType === "face" ? ScanFace : Fingerprint;

  const handleToggle = async (checked: boolean) => {
    if (checked) {
      const success = await enableBiometric();
      if (success) {
        hapticSuccess();
        toast.success(`${getBiometryName()} activé`);
      } else {
        hapticError();
        toast.error("Impossible d'activer la biométrie");
      }
    } else {
      disableBiometric();
      toast.success(`${getBiometryName()} désactivé`);
    }
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1">
            <CardTitle className="text-base">{getBiometryName()}</CardTitle>
            <CardDescription className="text-sm">
              Verrouillez l'app avec votre {biometryType === "face" ? "visage" : "empreinte"}
            </CardDescription>
          </div>
          <Switch 
            checked={isEnabled} 
            onCheckedChange={handleToggle}
          />
        </div>
      </CardHeader>
      {isEnabled && (
        <CardContent className="pt-0">
          <div className="flex items-center gap-2 text-sm text-success">
            <ShieldCheck className="w-4 h-4" />
            <span>Protection activée</span>
          </div>
        </CardContent>
      )}
    </Card>
  );
}
